import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../../../../hooks'
import { FormikField } from '../../../../../../../Formik'
import { InputField } from '../../../../../../../Input'
import { getApplicantFormOptionalLabel } from '../../../../../../../RentalPortalApplicant'
import {
  APPLICANT_IDENTITY_FIELD_NAME_PHONE,
  APPLICANT_IDENTITY_PHONE_MAX_LENGTH,
  QA_NAME_APPLICANT_IDENTITY_PHONE_INPUT,
} from '../../../ApplicantIdentityWidget.constants'

function ApplicantIdentityPhoneField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: getApplicantFormOptionalLabel({
          label: t('Inhabitant.PhoneLabelKey'),
          t,
        }),
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={APPLICANT_IDENTITY_PHONE_MAX_LENGTH}
      name={APPLICANT_IDENTITY_FIELD_NAME_PHONE}
      qaName={QA_NAME_APPLICANT_IDENTITY_PHONE_INPUT}
    />
  )
}

export default ApplicantIdentityPhoneField
